import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { insumosApi } from '@/lib/api';
import type { Filamento, Embalagem } from '@/types';

// Filamentos
export function useFilamentos() {
  return useQuery({
    queryKey: ['filamentos'],
    queryFn: async () => {
      const response = await insumosApi.listarFilamentos();
      const data = response.data;
      if (data && typeof data === 'object' && 'data' in data && Array.isArray(data.data)) {
        return data.data as Filamento[];
      }
      return (Array.isArray(data) ? data : []) as Filamento[];
    },
  });
}

export function useCriarFilamento() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: any) => insumosApi.criarFilamento(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['filamentos'] });
    },
  });
}

export function useAtualizarFilamento() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      insumosApi.atualizarFilamento(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['filamentos'] });
    },
  });
}

export function useDeletarFilamento() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id: string) => insumosApi.deletarFilamento(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['filamentos'] });
    },
  });
}

export function useBulkDeletarFilamentos() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (ids: string[]) => insumosApi.bulkDeletarFilamentos(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['filamentos'] });
    },
  });
}

// Embalagens
export function useEmbalagens() {
  return useQuery({
    queryKey: ['embalagens'],
    queryFn: async () => {
      const response = await insumosApi.listarEmbalagens();
      const data = response.data;
      if (data && typeof data === 'object' && 'data' in data && Array.isArray(data.data)) {
        return data.data as Embalagem[];
      }
      return (Array.isArray(data) ? data : []) as Embalagem[];
    },
  });
}

export function useCriarEmbalagem() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: any) => insumosApi.criarEmbalagem(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['embalagens'] });
    },
  });
}

export function useAtualizarEmbalagem() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      insumosApi.atualizarEmbalagem(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['embalagens'] });
    },
  });
}

export function useDeletarEmbalagem() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id: string) => insumosApi.deletarEmbalagem(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['embalagens'] });
    },
  });
}

export function useBulkDeletarEmbalagens() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (ids: string[]) => insumosApi.bulkDeletarEmbalagens(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['embalagens'] });
    },
  });
}

// Estatísticas
export function useEstatisticasInsumos() {
  return useQuery({
    queryKey: ['insumos-estatisticas'],
    queryFn: async () => {
      const response = await insumosApi.estatisticas();
      return response.data;
    },
  });
}
